import InventoryItem from 'admin/inventory/InventoryItem'
import { RefreshInventoryItems } from 'admin/inventory/InventorySearchViewModel'
import InventoryStore from 'admin/InventoryStore'
import { AlertFactory, AlertState } from 'alerts/Alert'
import Workspace from 'iam/models/Workspace'
import ModalViewModel from 'infra/ModalViewModel'
import { action, observable, makeObservable } from 'mobx'
import { task } from 'mobx-task'

/**
 * View model for managing the Archive dialog.
 */
export default class ArchiveItemViewModel extends ModalViewModel {
  @observable inventoryItem?: InventoryItem = undefined

  constructor(
    private inventoryStore: InventoryStore,
    private refreshItems: RefreshInventoryItems,
    private newAlert: AlertFactory,
    private selectWorkspaceForFiltering: (workspace: Workspace) => void,
  ) {
    super()
    makeObservable(this)
  }

  @action
  setInventoryItem(item: InventoryItem) {
    this.inventoryItem = item
  }

  @action
  open(item: InventoryItem) {
    this.setInventoryItem(item)
    this.show()
  }

  /**
   * Archives the item.
   */
  archive = task.resolved(async () => {
    if (this.inventoryItem) {
      await this.inventoryStore.archive(this.inventoryItem.id)
      await this.inventoryStore.fetchWorkspacesWithInventoryItems()
      this.selectWorkspaceForFiltering(
        this.inventoryItem.workspace || Workspace.none,
      )

      await this.refreshItems(this.inventoryItem.workspace || Workspace.none)

      this.newAlert()
        .withState(AlertState.Success)
        .saying('Success', 'Item archived.')
        .autoDismiss()
        .show()
      this.close()
    }
  })
}
